export default __webpack_public_path__ + "static/img/roz.d5e4ead.png";